/**
 * @generated SignedSource<<e7771e12f3cf34bceb0f142a101ccda0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiningBookingSummary_booking$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BookingConfirmedModal_Booking" | "BookingHeaderFragment_booking" | "BookingInfo_Booking" | "DiningPolicySection_booking" | "DiningReservationFooter_booking" | "DiningReservationSection_booking" | "DiningSpecialRequestsSection_booking" | "useGetBookingAnalyticsMetadata_booking">;
  readonly " $fragmentType": "DiningBookingSummary_booking";
};
export type DiningBookingSummary_booking$key = {
  readonly " $data"?: DiningBookingSummary_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningBookingSummary_booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningBookingSummary_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingAnalyticsMetadata_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingHeaderFragment_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingInfo_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningReservationSection_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningSpecialRequestsSection_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningPolicySection_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningReservationFooter_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingConfirmedModal_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "53cff1c6dfab5e03ab525cf527703fcf";

export default node;
